export default __webpack_public_path__ + "static/media/screenshot2_sm.8cff6b84.jpg";